import { ExtractRecordPaths, RaRecord, useFieldValue } from 'ra-core';
import CopyButton from '../../ui/CopyButton';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';

type Props<R extends RaRecord> = {
  label: string;
  source: ExtractRecordPaths<R>;
  record?: Record<any, any>;
  copyable?: boolean;
  defaultValue?: any;
  helperText?: string;
  highlight?: boolean;
};

function OneLineTextField<R extends RaRecord>({
  label,
  source,
  record,
  copyable = true,
  helperText,
  highlight,
}: Props<R>) {
  const value = useFieldValue({ source, record });

  return (
    <div className="mb-4">
      <Label htmlFor={label} className="text-xs text-muted-foreground mb-1">
        {label}
      </Label>
      <div className="relative flex items-center">
        <Input
          id={label}
          value={value ?? ''}
          readOnly
          className={cn(
            'pr-10 text-sm text-muted-foreground',
            highlight &&
              'ring-1 ring-violet/60 shadow-[0_0_10px_-2px_var(--gl-violet)]'
          )}
        />
        {copyable && value && (
          <div className="absolute right-1">
            <CopyButton text={value} />
          </div>
        )}
      </div>
      {helperText && (
        <div className="mt-2 flex items-start gap-2 rounded-md border border-border bg-secondary px-3 py-2">
          <Info className="size-3.5 text-muted-foreground shrink-0 mt-px" />
          <p className="text-xs text-muted-foreground leading-relaxed">
            {helperText}
          </p>
        </div>
      )}
    </div>
  );
}

export default OneLineTextField;
